/* global mapboxgl */
import { gtm } from '../modules/gtm.js';

const HOTEL_SVG = `<svg width="44" height="55" viewBox="0 0 44 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C9.86108 0 0 9.97862 0 22.2603C0 30.0115 4.01077 37.7386 10.6886 45.1496C12.943 47.6487 15.3654 49.986 17.9385 52.1446C18.7931 52.8784 19.6206 53.5333 20.3195 54.0832C20.7595 54.3978 21.0963 54.6332 21.2503 54.7638C21.4716 54.9177 21.7335 55 22.0017 55C22.2699 55 22.5318 54.9177 22.7531 54.7638C22.9071 54.6332 23.2438 54.3978 23.6838 54.0832C24.3828 53.5333 25.2103 52.8784 26.0649 52.1446C28.6373 49.9865 31.0592 47.6498 33.3131 45.1513C39.9875 37.7386 44 30.0132 44 22.2603C44 9.97862 34.1389 0 22 0Z" fill="#062423"/><path d="M12 14.1875C12 13.5307 12.5307 13 13.1875 13H29.8125C30.4693 13 31 13.5307 31 14.1875C31 14.8443 30.4693 15.375 29.8125 15.375V29.625C30.4693 29.625 31 30.1557 31 30.8125C31 31.4693 30.4693 32 29.8125 32H23.2812V30.2188C23.2812 29.2354 22.4834 28.4375 21.5 28.4375C20.5166 28.4375 19.7188 29.2354 19.7188 30.2188V32H13.1875C12.5307 32 12 31.4693 12 30.8125C12 30.1557 12.5307 29.625 13.1875 29.625V15.375C12.5307 15.375 12 14.8443 12 14.1875ZM15.5625 17.1562V18.3438C15.5625 18.6703 15.8297 18.9375 16.1562 18.9375H17.3438C17.6703 18.9375 17.9375 18.6703 17.9375 18.3438V17.1562C17.9375 16.8297 17.6703 16.5625 17.3438 16.5625H16.1562C15.8297 16.5625 15.5625 16.8297 15.5625 17.1562ZM20.9062 16.5625C20.5797 16.5625 20.3125 16.8297 20.3125 17.1562V18.3438C20.3125 18.6703 20.5797 18.9375 20.9062 18.9375H22.0938C22.4203 18.9375 22.6875 18.6703 22.6875 18.3438V17.1562C22.6875 16.8297 22.4203 16.5625 22.0938 16.5625H20.9062ZM25.0625 17.1562V18.3438C25.0625 18.6703 25.3297 18.9375 25.6562 18.9375H26.8438C27.1703 18.9375 27.4375 18.6703 27.4375 18.3438V17.1562C27.4375 16.8297 27.1703 16.5625 26.8438 16.5625H25.6562C25.3297 16.5625 25.0625 16.8297 25.0625 17.1562ZM16.1562 20.125C15.8297 20.125 15.5625 20.3922 15.5625 20.7188V21.9062C15.5625 22.2328 15.8297 22.5 16.1562 22.5H17.3438C17.6703 22.5 17.9375 22.2328 17.9375 21.9062V20.7188C17.9375 20.3922 17.6703 20.125 17.3438 20.125H16.1562ZM20.3125 20.7188V21.9062C20.3125 22.2328 20.5797 22.5 20.9062 22.5H22.0938C22.4203 22.5 22.6875 22.2328 22.6875 21.9062V20.7188C22.6875 20.3922 22.4203 20.125 20.9062 20.125H20.9062C20.5797 20.125 20.3125 20.3922 20.3125 20.7188ZM25.6562 20.125C25.3297 20.125 25.0625 20.3922 25.0625 20.7188V21.9062C25.0625 22.2328 25.3297 22.5 25.6562 22.5H26.8438C27.1703 22.5 27.4375 22.2328 27.4375 21.9062V20.7188C27.4375 20.3922 27.1703 20.125 26.8438 20.125H25.6562ZM24.1719 27.25C24.6654 27.25 25.0736 26.8455 24.9512 26.3668C24.5578 24.8268 23.1625 23.6875 21.5 23.6875C19.8375 23.6875 18.4385 24.8268 18.0488 26.3668C17.9264 26.8418 18.3383 27.25 18.8281 27.25H24.1719Z" fill="white"/></svg>`;

const isTouchDevice = () => window.matchMedia("(hover: none) and (pointer: coarse)").matches;

function haversine(lat1, lng1, lat2, lng2) {
	const R = 6371;
	const dLat = ((lat2 - lat1) * Math.PI) / 180;
	const dLng = ((lng2 - lng1) * Math.PI) / 180;
	const a =
		Math.sin(dLat / 2) ** 2 +
		Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
	return R * 2 * Math.asin(Math.sqrt(a));
}

export const hotelMethods = {
	// ── Nearby hotels (itinerary detail) ─────────────────────────────────────

	async _fetchNearbyHotels(lat, lng) {
		const s = window.lbhMapStrings || {};
		const listEl = document.getElementById("hotel-list");
		listEl.innerHTML = `<li class="hotel-loading">${s.hotelLoading || "Caricamento strutture..."}</li>`;
		try {
			const params = new URLSearchParams({
				lat,
				lng,
				radius: 50,
				...(this.lang ? { lang: this.lang } : {}),
			});
			const res = await fetch(`${this.apiBase}/accommodations-near?${params}`);
			if (!res.ok) {
				const body = await res.text();
				console.error(`LBHMap: hotel API returned ${res.status}`, body);
				listEl.innerHTML = `<li class="hotel-error">${s.hotelError || "Errore nel caricamento delle strutture."}</li>`;
				return;
			}
			const data = await res.json();
			const hotels = data.hotels || [];
			this._renderHotelList(hotels);
			this._renderHotelMarkers(hotels);
		} catch (err) {
			console.error("LBHMap: hotel fetch error", err);
			const s2 = window.lbhMapStrings || {};
			document.getElementById("hotel-list").innerHTML =
				`<li class="hotel-error">${s2.hotelError || "Errore nel caricamento delle strutture."}</li>`;
		}
	},

	_renderHotelList(hotels) {
		const s = window.lbhMapStrings || {};
		const listEl = document.getElementById("hotel-list");

		if (!hotels.length) {
			listEl.innerHTML = `<li class="hotel-empty">${s.noHotels || "Nessuna struttura nel raggio di 50 km."}</li>`;
			return;
		}

		listEl.innerHTML = hotels
			.map(
				(h) => `
			<li class="hotel-item" data-hotel-id="${h.id}">
				<div class="hotel-card">
					${
						h.thumbnail
							? `<img src="${h.thumbnail}" alt="${h.title}" class="hotel-thumb">`
							: '<span class="hotel-thumb hotel-thumb--empty"></span>'
					}
					<div class="hotel-info">
						<span class="hotel-name">${h.title}</span>
						${h.region ? `<span class="hotel-region">${h.region}</span>` : ""}
						<span class="hotel-dist">${h.distance} km</span>
						${h.has_promo ? `<span class="hotel-promo-badge">${s.promoActive || "Promo Attiva"}</span>` : ""}
					</div>
				</div>
			</li>`,
			)
			.join("");

		hotels.forEach((h) => {
			const item = listEl.querySelector(`[data-hotel-id="${h.id}"]`);
			if (item) item.addEventListener("click", () => this._flyToHotel(h));
		});
	},

	_renderHotelMarkers(hotels) {
		this._clearHotelMarkers();

		// Shared lightweight tooltip shown on hover — pointer-events:none via CSS
		this._hoverTooltip = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			className: "hotel-tooltip",
			focusAfterOpen: false,
			offset: [0, -65],
			maxWidth: "none",
		});

		hotels.forEach((h) => {
			if (!h.lat || !h.lng) return;

			const el = document.createElement("div");
			el.className = "hotel-marker";
			el.setAttribute("aria-label", h.title);
			el.innerHTML = HOTEL_SVG;

			const s = window.lbhMapStrings || {};

			// Full interactive popup — only shown on click via _flyToHotel
			const popup = new mapboxgl.Popup({
				closeButton: true,
				closeOnClick: false,
				offset: [0, -10],
				className: "hotel-popup",
				maxWidth: "260px",
			}).setHTML(`
				<div class="hotel-popup__inner">
					${h.thumbnail ? `<img src="${h.thumbnail}" alt="${h.title}" class="hotel-popup__img">` : ""}
					<div class="hotel-popup__body">
						<strong class="hotel-popup__name">${h.title}</strong>
						${h.region ? `<span class="hotel-popup__region">${h.region}</span>` : ""}
						<span class="hotel-popup__dist">${h.distance} km</span>
						${h.has_promo ? `<span class="hotel-popup__promo">${s.promoActive || "Promo Attiva"}</span>` : ""}
					</div>
					<a href="${h.permalink}" class="hotel-popup__cta" target="_blank" rel="noopener">
						${s.goToHotel || "Vai all'hotel"}
					</a>
				</div>`);

			const marker = new mapboxgl.Marker({ element: el, anchor: "bottom" })
				.setLngLat([h.lng, h.lat])
				.addTo(this.map);

			// Prevent Mapbox drag-detection from absorbing the click
			el.addEventListener("mousedown", (e) => e.stopPropagation());

			// Hover: lightweight tooltip — skipped on touch to avoid double-tap
			el.addEventListener("mouseenter", () => {
				if (isTouchDevice()) return;
				this._hoverTooltip
					.setLngLat([h.lng, h.lat])
					.setHTML(`<div class="hotel-tooltip__inner"><strong>${h.title}</strong>${h.distance ? `<span>${h.distance} km</span>` : ""}</div>`)
					.addTo(this.map);
			});
			el.addEventListener("mouseleave", () => {
				if (isTouchDevice()) return;
				this._hoverTooltip?.remove();
			});

			// Click: dismiss tooltip, open full popup via flyTo
			el.addEventListener("click", (e) => {
				e.stopPropagation();
				this._hoverTooltip?.remove();
				this._flyToHotel(h);
			});

			popup.on("close", () => {
				if (this._activePinnedHotelId === h.id) {
					this._activePinnedHotelId = null;
				}
			});

			this._hotelMarkers.push({ id: h.id, marker, popup });
		});
	},

	_flyToHotel(h) {
		gtm.clickHotelMap({ hotel_id: h.id, hotel_name: h.title, hotel_region: h.region || "" });
		this._hoverTooltip?.remove();
		this._hotelMarkers.forEach((item) => item.popup.remove());
		this._activePinnedHotelId = h.id;
		this.map.flyTo({ center: [h.lng, h.lat], zoom: 14, duration: 800 });

		const item = this._hotelMarkers.find((m) => m.id === h.id);
		if (item) item.popup.setLngLat([h.lng, h.lat]).addTo(this.map);

		// Highlight the matching card in the nearby-hotels sidebar list and scroll to it.
		const listEl = document.getElementById("hotel-list");
		if (listEl) {
			listEl.querySelectorAll("[data-hotel-id]").forEach((el) => el.classList.remove("is-selected"));
			const card = listEl.querySelector(`[data-hotel-id="${h.id}"]`);
			if (card) {
				card.classList.add("is-selected");
				card.scrollIntoView({ behavior: "smooth", block: "nearest" });
			}
		}
	},

	_closeAllHotelPopups() {
		this._activePinnedHotelId = null;
		this._hotelMarkers.forEach((item) => item.popup.remove());
	},

	_clearHotelMarkers() {
		this._activePinnedHotelId = null;
		this._hoverTooltip?.remove();
		this._hoverTooltip = null;
		this._hotelMarkers.forEach(({ marker, popup }) => {
			popup.remove();
			marker.remove();
		});
		this._hotelMarkers = [];
	},

	// ── All hotels mode ───────────────────────────────────────────────────────

	_initAllHotelMarkers() {
		this._clearAllHotelMarkers();

		// Shared lightweight tooltip for hover (name + region, pointer-events:none via CSS)
		this._allHoverTooltip = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			className: "hotel-tooltip",
			focusAfterOpen: false,
			offset: [0, -65],
			maxWidth: "none",
		});

		this.hotels.forEach((h) => {
			if (!h.lat || !h.lng) return;

			const el = document.createElement("div");
			el.className = "hotel-marker hotel-marker--all";
			el.setAttribute("aria-label", h.title);
			el.innerHTML = HOTEL_SVG;

			const s = window.lbhMapStrings || {};

			// Full interactive popup — shown on click
			const popup = new mapboxgl.Popup({
				closeButton: true,
				closeOnClick: false,
				offset: [0, -10],
				className: "hotel-popup",
				maxWidth: "260px",
			}).setHTML(`
				<div class="hotel-popup__inner">
					${h.thumbnail ? `<img src="${h.thumbnail}" alt="${h.title}" class="hotel-popup__img">` : ""}
					<div class="hotel-popup__body">
						<strong class="hotel-popup__name">${h.title}</strong>
						${h.region ? `<span class="hotel-popup__region">${h.region}</span>` : ""}
						${h.has_promo ? `<span class="hotel-popup__promo">${s.promoActive || "Promo Attiva"}</span>` : ""}
					</div>
					<a href="${h.permalink}" class="hotel-popup__cta" target="_blank" rel="noopener">
						${s.goToHotel || "Vai all'hotel"}
					</a>
				</div>`);

			const marker = new mapboxgl.Marker({ element: el, anchor: "bottom" })
				.setLngLat([h.lng, h.lat])
				.addTo(this.map);

			const { hasPromo, rating } = this.hotelFilters;
			const isVisible = (!hasPromo || h.has_promo) && (rating === 0 || h.rating >= rating);
			if (!isVisible) el.style.display = "none";

			// Prevent Mapbox drag-detection from absorbing the click
			el.addEventListener("mousedown", (e) => e.stopPropagation());

			// Hover: lightweight tooltip — skipped on touch to avoid double-tap
			el.addEventListener("mouseenter", () => {
				if (isTouchDevice()) return;
				this._allHoverTooltip
					.setLngLat([h.lng, h.lat])
					.setHTML(`<div class="hotel-tooltip__inner"><strong>${h.title}</strong>${h.region ? `<span>${h.region}</span>` : ""}</div>`)
					.addTo(this.map);
			});
			el.addEventListener("mouseleave", () => {
				if (isTouchDevice()) return;
				this._allHoverTooltip?.remove();
			});
			el.addEventListener("click", (e) => {
				e.stopPropagation();
				this._allHoverTooltip?.remove();
				// _openHotelDetail removes all popups internally, so we re-add ours after
				this._openHotelDetail(h);
				popup.setLngLat([h.lng, h.lat]).addTo(this.map);
			});

			this._allHotelMarkers.push({ id: h.id, el, marker, popup });
		});
	},

	_clearAllHotelMarkers() {
		this._allHoverTooltip?.remove();
		this._allHoverTooltip = null;
		this._allHotelMarkers.forEach(({ marker, popup }) => {
			popup?.remove();
			marker.remove();
		});
		this._allHotelMarkers = [];
	},

	// ── Hotel list (hotel mode sidebar) ──────────────────────────────────────

	_initHotelAllList() {
		const listEl = document.getElementById("hotel-all-list");
		const searchEl = document.getElementById("hotel-search");
		if (!listEl) return;

		const render = (query = "") => {
			const s = window.lbhMapStrings || {};
			// getBounds() in Mapbox GL JS v3 respects padding, so on mobile with the
			// 70vh sidebar it only covers the visible strip. Use unproject on canvas
			// corners to get the full canvas bounds regardless of padding.
			const canvas = this.map.getCanvas();
			const nw = this.map.unproject([0, 0]);
			const se = this.map.unproject([canvas.clientWidth, canvas.clientHeight]);
			const bounds = new mapboxgl.LngLatBounds();
			bounds.extend(nw);
			bounds.extend(se);
			const center = this.map.getCenter();
			const q = query.trim().toLowerCase();
			const { hasPromo, rating } = this.hotelFilters;

			let visible = this.hotels
				.filter((h) => {
					if (!h.lat || !h.lng || isNaN(h.lat) || isNaN(h.lng)) return false;
					if (!bounds.contains([h.lng, h.lat])) return false;
					if (q && !h.title.toLowerCase().includes(q)) return false;
					if (hasPromo && !h.has_promo) return false;
					if (rating > 0 && h.rating < rating) return false;
					return true;
				})
				.map((h) => ({
					...h,
					_dist: haversine(center.lat, center.lng, h.lat, h.lng),
				}))
				.sort((a, b) => a._dist - b._dist);

			if (!visible.length) {
				listEl.innerHTML = `<li class="iti-empty">${s.noHotelsInView || "Nessun hotel in questa area."}</li>`;
				return;
			}

			listEl.innerHTML = visible
				.map(
					(h) => `
				<li class="iti-card" data-hotel-all-id="${h.id}">
					${
						h.thumbnail
							? `<img src="${h.thumbnail}" alt="${h.title}" class="iti-card__img">`
							: '<span class="iti-card__img iti-card__img--empty"></span>'
					}
					<div class="iti-card__body">
						${h.region ? `<div class="iti-card__tags"><span class="detail-tag">${h.region}</span></div>` : ""}
						<strong class="iti-card__title">${h.title}</strong>
						<div class="iti-card__meta">
							${
								h.rating
									? `<div class="iti-card__dots">
								${Array.from({ length: 5 }, (_, i) => `<span class="dot${i < h.rating ? " is-filled" : ""}"></span>`).join("")}
							</div>`
									: ""
							}
							${h.has_promo ? `<span class="hotel-promo-badge hotel-promo-badge--xs">${s.promoActive || "Promo"}</span>` : ""}
						</div>
					</div>
				</li>`,
				)
				.join("");

			visible.forEach((h) => {
				const card = listEl.querySelector(`[data-hotel-all-id="${h.id}"]`);
				if (!card) return;
				card.addEventListener("click", () => this._openHotelDetail(h));
			});
		};

		this._renderHotelAllList = render;

		this.map.on("moveend", () => {
			if (this.mode !== "accommodations" || this.activeHotelId) return;
			render(searchEl?.value || "");
		});

		if (searchEl) {
			searchEl.addEventListener("input", () => render(searchEl.value));
		}
	},

	// ── Nearby itineraries (hotel detail) ────────────────────────────────────

	_renderNearbyItineraries(lat, lng) {
		const listEl = document.getElementById("nearby-iti-list");
		const s = window.lbhMapStrings || {};
		if (!listEl) return;

		const RADIUS = 50;
		const nearby = this.itineraries
			.map((iti) => ({ ...iti, _dist: haversine(lat, lng, iti.lat, iti.lng) }))
			.filter((iti) => iti._dist <= RADIUS)
			.sort((a, b) => a._dist - b._dist);

		if (!nearby.length) {
			listEl.innerHTML = `<li class="iti-empty">${s.noNearbyItineraries || "Nessun itinerario nel raggio di 50 km."}</li>`;
			this._clearNearbyItiMarkers();
			return;
		}

		listEl.innerHTML = nearby.map((iti) => {
			const diff = iti.difficulty || 0;
			const dots = Array.from({ length: 5 }, (_, i) =>
				`<span class="dot${i < diff ? " is-filled" : ""}"></span>`
			).join("");
			const diffLabel = s.diffLabels && s.diffLabels[diff] ? s.diffLabels[diff] : "";

			return `
			<li class="iti-card" data-nearby-iti-id="${iti.id}">
				<div class="iti-card__main">
					${iti.thumbnail
						? `<img src="${iti.thumbnail}" alt="${iti.title}" class="iti-card__img">`
						: '<span class="iti-card__img iti-card__img--empty"></span>'}
					<div class="iti-card__body">
						${iti.region ? `<div class="iti-card__tags"><span class="detail-tag">${iti.region}</span></div>` : ""}
						<strong class="iti-card__title">${iti.title}</strong>
						<div class="iti-card__meta">
							<div class="iti-card__dots">${dots}</div>
							<span class="iti-card__dist">${Math.round(iti._dist * 10) / 10} km</span>
							<button class="iti-card__expand" aria-label="${s.expandDetails || "Expand details"}" aria-expanded="false">+</button>
						</div>
					</div>
				</div>
				<div class="iti-card__extra" hidden>
					${iti.description ? `<p class="iti-card__desc">${iti.description}</p>` : ""}
					<div class="iti-card__extra-stats">
						${iti.duration  ? `<span class="iti-card__extra-stat"><strong>${s.duration  || "Duration"}:</strong> ${iti.duration} h</span>`   : ""}
						${iti.distance  ? `<span class="iti-card__extra-stat"><strong>${s.distance  || "Distance"}:</strong> ${iti.distance} km</span>`   : ""}
						${iti.climb     ? `<span class="iti-card__extra-stat"><strong>${s.climb     || "Elevation gain"}:</strong> ${iti.climb} m</span>` : ""}
						${diffLabel     ? `<span class="iti-card__extra-stat"><strong>${s.difficulty || "Difficulty"}:</strong> ${diffLabel}</span>`       : ""}
					</div>
					${iti.bike_types && iti.bike_types.length ? `
					<div class="iti-card__bike-types">
						${iti.bike_types.map((t) => `<span class="detail-tag">${t}</span>`).join("")}
					</div>` : ""}
					<div class="iti-card__elevation" id="iti-chart-${iti.id}"></div>
				</div>
			</li>`;
		}).join("");

		nearby.forEach((iti) => {
			const item = listEl.querySelector(`[data-nearby-iti-id="${iti.id}"]`);
			if (!item) return;

			const toggle = () => {
				const extra     = item.querySelector(".iti-card__extra");
				const expandBtn = item.querySelector(".iti-card__expand");
				const isExpanded = extra && !extra.hidden;

				// Accordion: collapse every other open card first
				listEl.querySelectorAll("[data-nearby-iti-id]").forEach((other) => {
					if (other === item) return;
					const otherExtra = other.querySelector(".iti-card__extra");
					const otherBtn   = other.querySelector(".iti-card__expand");
					if (otherExtra && !otherExtra.hidden) {
						otherExtra.hidden = true;
						if (otherBtn) { otherBtn.textContent = "+"; otherBtn.setAttribute("aria-expanded", "false"); }
						other.classList.remove("is-selected");
					}
				});

				// Toggle this card
				if (extra) {
					extra.hidden = isExpanded;
					if (expandBtn) {
						expandBtn.textContent = isExpanded ? "+" : "−";
						expandBtn.setAttribute("aria-expanded", String(!isExpanded));
					}
				}

				this._highlightNearbyItinerary(isExpanded ? null : iti.id);
			};

			item.addEventListener("click", toggle);

			const expandBtn = item.querySelector(".iti-card__expand");
			if (expandBtn) {
				expandBtn.addEventListener("click", (e) => { e.stopPropagation(); toggle(); });
			}

			const extraEl = item.querySelector(".iti-card__extra");
			if (extraEl) extraEl.addEventListener("click", (e) => e.stopPropagation());
		});

		this._renderNearbyItiMarkers(nearby);
		this._loadAllNearbyGPX(nearby);
	},

	// ── Nearby itinerary markers (hotel detail) ───────────────────────────────

	_renderNearbyItiMarkers(nearby) {
		this._clearNearbyItiMarkers();

		const features = nearby
			.filter((iti) => iti.lat && iti.lng)
			.map((iti) => ({
				type: "Feature",
				properties: { id: iti.id, title: iti.title },
				geometry: { type: "Point", coordinates: [iti.lng, iti.lat] },
			}));

		if (!features.length) return;

		this.map.addSource("nearby-itineraries", {
			type: "geojson",
			data: { type: "FeatureCollection", features },
		});
		this.map.addLayer({
			id:     "nearby-itineraries-layer",
			type:   "symbol",
			source: "nearby-itineraries",
			layout: {
				"icon-image":         "itinerary-pin",
				"icon-size":          0.8,
				"icon-anchor":        "bottom",
				"icon-allow-overlap": true,
			},
		});

		// Click: sync map marker → sidebar card
		this._nearbyItiClickHandler = (e) => {
			if (!e.features.length) return;
			const id = parseInt(e.features[0].properties.id, 10);
			this._highlightNearbyItinerary(id);
		};
		this._nearbyItiEnterHandler = () => { this.map.getCanvas().style.cursor = "pointer"; };
		this._nearbyItiLeaveHandler = () => { this.map.getCanvas().style.cursor = ""; };

		this.map.on("click",      "nearby-itineraries-layer", this._nearbyItiClickHandler);
		this.map.on("mouseenter", "nearby-itineraries-layer", this._nearbyItiEnterHandler);
		this.map.on("mouseleave", "nearby-itineraries-layer", this._nearbyItiLeaveHandler);

		this._nearbyItiMarkersAdded = true;
	},

	_clearNearbyItiMarkers() {
		if (this._nearbyItiClickHandler) {
			this.map.off("click",      "nearby-itineraries-layer", this._nearbyItiClickHandler);
			this.map.off("mouseenter", "nearby-itineraries-layer", this._nearbyItiEnterHandler);
			this.map.off("mouseleave", "nearby-itineraries-layer", this._nearbyItiLeaveHandler);
			this._nearbyItiClickHandler = null;
			this._nearbyItiEnterHandler = null;
			this._nearbyItiLeaveHandler = null;
		}
		if (this._nearbyItiMarkersAdded) {
			if (this.map.getLayer("nearby-itineraries-layer")) this.map.removeLayer("nearby-itineraries-layer");
			if (this.map.getSource("nearby-itineraries"))     this.map.removeSource("nearby-itineraries");
			this._nearbyItiMarkersAdded = false;
		}
		this._clearNearbyGPXLayers();
	},

	// ── Nearby itinerary highlight (map ↔ sidebar sync in hotel detail) ───────

	_highlightNearbyItinerary(id) {
		// Update icon-size: selected marker normal, others dimmed; all normal when null
		if (this.map.getLayer("nearby-itineraries-layer")) {
			this.map.setLayoutProperty(
				"nearby-itineraries-layer",
				"icon-size",
				id != null
					? ["case", ["==", ["get", "id"], id], 1.0, 0.55]
					: 0.8
			);
		}

		// Update GPX track colors: selected = bold highlight, others = dimmed
		this._nearbyGPXLayerIds.forEach(({ layerId, itiId }) => {
			if (!this.map.getLayer(layerId)) return;
			if (id == null) {
				this.map.setPaintProperty(layerId, "line-color",   "#062423");
				this.map.setPaintProperty(layerId, "line-opacity", 0.7);
				this.map.setPaintProperty(layerId, "line-width",   2.5);
			} else if (itiId === id) {
				this.map.setPaintProperty(layerId, "line-color",   "#E63946");
				this.map.setPaintProperty(layerId, "line-opacity", 1.0);
				this.map.setPaintProperty(layerId, "line-width",   4);
			} else {
				this.map.setPaintProperty(layerId, "line-color",   "#062423");
				this.map.setPaintProperty(layerId, "line-opacity", 0.2);
				this.map.setPaintProperty(layerId, "line-width",   2);
			}
		});
		// Sync sidebar card
		document.querySelectorAll("[data-nearby-iti-id].is-selected")
			.forEach((el) => el.classList.remove("is-selected"));
		if (id != null) {
			const card = document.querySelector(`[data-nearby-iti-id="${id}"]`);
			if (card) {
				// Accordion: collapse all other open cards
				document.querySelectorAll("[data-nearby-iti-id]").forEach((other) => {
					if (other === card) return;
					const otherExtra = other.querySelector(".iti-card__extra");
					const otherBtn   = other.querySelector(".iti-card__expand");
					if (otherExtra && !otherExtra.hidden) {
						otherExtra.hidden = true;
						if (otherBtn) { otherBtn.textContent = "+"; otherBtn.setAttribute("aria-expanded", "false"); }
						other.classList.remove("is-selected");
					}
				});
				// Expand this card if not already open
				const extra     = card.querySelector(".iti-card__extra");
				const expandBtn = card.querySelector(".iti-card__expand");
				if (extra && extra.hidden) {
					extra.hidden = false;
					if (expandBtn) {
						expandBtn.textContent = "−";
						expandBtn.setAttribute("aria-expanded", "true");
					}
				}
				card.classList.add("is-selected");
				card.scrollIntoView({ behavior: "smooth", block: "nearest" });
			}
		}
	},
};
